import { isEqualUndefinedOrEmpty, isDeepProp, cloneDeep, setDeepProp, deleteUndefinedProps, mergeOrDelete } from '../../../utils/js.js';
import { InputStates } from '../FieldControlled/common.js';

function isValidationValid(validation) {
    const { state } = validation || {};
    return state !== InputStates.alarm && state !== InputStates.loading;
}
function isFormValid(validations) {
    return !Object.values(validations).some((val) => !isValidationValid(val));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mergeFormValues(values, name, value) {
    // TODO gestire meglio il merge per evitare cambi di stato inutili. Anche per deep props.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (values && isEqualUndefinedOrEmpty(values[name], value) && !isDeepProp(name))
        return values;
    const newValues = cloneDeep(values);
    setDeepProp(name, value, newValues, values);
    deleteUndefinedProps(newValues);
    return newValues;
}
function mergeFormValidations(validations, name, validation) {
    const { state: newState, stateMessage: newStateMessage } = validation || {};
    const { state, stateMessage } = (validations && validations[name]) || {};
    if (newState === state && isEqualUndefinedOrEmpty(newStateMessage, stateMessage))
        return validations;
    return mergeOrDelete(validations, name, validation);
}

export { isFormValid, isValidationValid, mergeFormValidations, mergeFormValues };
